// @ts-nocheck
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import style from "./LicenseChangeModal.module.scss";
import { SecondaryBtn } from "./SecondaryBtn";
import { InfoBtn } from "./InfoBtn";
import axios from "axios";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export const LicenseChangeModal = ({
  client,
  handleClose,
  currentUserLicense,
  membersCount,
  currentPlan,
  setCurrentUserLicense,
  fetchLicenseDowngradeInfo,
  getNextPayment,
  defaultLicenseCount,
}) => {
  const { t } = useTranslation();

  const [licenseCount, setLicenseCount] = useState(0);
  const [currentPageNum, setCurrentPageNum] = useState(0);
  const [licenseChangeAfterInfo, setLicenseChangeAfterInfo] = useState({});

  const licenseChangeCheck = async () => {
    await axios
      .get(`/${client}/settings/client_license_logs/fetch_billing_license`, {
        params: {
          after_count: licenseCount,
        },
      })
      .then((res) => {
        setLicenseChangeAfterInfo(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const licenseChange = async () => {
    const licenseChangeStatus = licenseCount >= currentUserLicense ? "upgrade" : "downgrade";

    await axios
      .patch(`/${client}/settings/client_license_logs/${licenseChangeStatus}`, {
        client_license_log: {
          count: licenseCount,
        },
      })
      .then((res) => {
        setCurrentUserLicense(res.data.count);
        fetchLicenseDowngradeInfo();
        getNextPayment();
        handleClose();
      })
      .catch((_) => {
        return;
      });
  };

  useEffect(() => {
    setLicenseCount(currentUserLicense);
  }, []);

  return (
    <>
      {currentPageNum === 0 ? (
        <div className={style.licenseChangeModalWrap}>
          <span className={style.licenseChangeTitle}>{t("LicenseChangeModal.ライセンス数の変更")}</span>
          <div className={style.licenseChangeContent}>
            <div className={style.licenseChangeCountFormWrap}>
              <input
                className={style.licenseChangeCountForm}
                data-testid="test-license-count"
                value={licenseCount}
                type="number"
                readOnly
              />
              <div
                className={style.licenseCountIcon}
                data-testid="test-license-minus-change"
                style={{
                  cursor: licenseCount <= membersCount || licenseCount <= defaultLicenseCount ? "default" : "pointer",
                }}
                onClick={() =>
                  licenseCount <= membersCount || licenseCount <= defaultLicenseCount
                    ? ""
                    : setLicenseCount((prevCount) => prevCount - 1)
                }
              >
                <img
                  src={
                    licenseCount <= membersCount
                      ? `${getImageUrl("images/icons/minusGray.svg")}`
                      : `${getImageUrl("images/icons/minus.svg")}`
                  }
                  width={20}
                  height={20}
                  style={{
                    paddingTop: "2px",
                    display: "block",
                    margin: "auto",
                  }}
                />
              </div>
              <div className={style.licenseCountIcon} data-testid="test-license-add-change">
                <img
                  src={getImageUrl("images/icons/add.svg")}
                  width={20}
                  height={20}
                  style={{
                    paddingTop: "2px",
                    display: "block",
                    margin: "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => setLicenseCount((prevCount) => prevCount + 1)}
                />
              </div>
            </div>
            <div className={style.licenseCurrentCount}>
              {t("LicenseChangeModal.current_license_count", { currentUserLicense: currentUserLicense })}
              {defaultLicenseCount !== 0 && (
                <div style={{ fontSize: "13px" }}>
                  {t("LicenseChangeModal.free_license_count", { defaultLicenseCount: defaultLicenseCount })}
                </div>
              )}
              <div style={{ paddingTop: "10px", fontSize: "12px" }}>
                {t("LicenseChangeModal.現在登録されているメンバー数以下に設定することはできません")}
                <br />
                {t("LicenseChangeModal.ご利用中プランの無料ライセンス数以下に設定することはできません")}
              </div>
            </div>
          </div>
          <div className={style.licenseChangeButtonWrap}>
            <SecondaryBtn
              text={t("LicenseChangeModal.キャンセル")}
              disabled={false}
              className="test-force-upgrade"
              submit={() => handleClose()}
              style={{ color: "#222222", maxWidth: "194px", minWidth: "194px", width: "194px" }}
            />
            <InfoBtn
              text={t("LicenseChangeModal.次へ")}
              loading={false}
              className="ml-auto test-force-upgrade"
              style={{ maxWidth: "194px", minWidth: "194px", width: "194px" }}
              submit={() => {
                licenseChangeCheck();
                setCurrentPageNum(1);
              }}
              disabled={licenseCount === currentUserLicense ? true : false}
            />
          </div>
        </div>
      ) : (
        <div className={style.licenseChangeModalWrap}>
          <span className={style.licenseChangeTitle}>{t("LicenseChangeModal.ライセンスの変更申し込み")}</span>

          {licenseCount >= currentUserLicense ? (
            <>
              {currentPlan.interval === t("LicenseChangeModal.月間契約") ? (
                <>
                  <div>
                    {t(
                      "LicenseChangeModal.ライセンスの追加は即時適用され、今月分から請求されます。この変更は取り消すことができません。変更内容をご確認の上、「申し込む」をクリックしてください。",
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div>
                    {t("LicenseChangeModal.licenseAdditionBillingNotice", {
                      months: licenseChangeAfterInfo?.billable_month_count,
                    })}
                  </div>
                </>
              )}
              <div className={style.licenseModalContentWrap}>
                <div className={style.licenseModalStartingDate}>
                  <div className={style.licenseModalStartingDateItem}>{t("LicenseChangeModal.適用月")}</div>
                  <div className={style.licenseModalStartingDateValue}>
                    {licenseChangeAfterInfo?.apply_date?.upgrade}
                  </div>
                </div>
                <div className={style.licenseModalLicenseContent}>
                  <div className={style.licenseModalLicenseContent}>
                    <div className={style.licenseModalLicenseItem}>
                      <div className={style.licenseModalLicenseItemName}>
                        {t("LicenseChangeModal.追加ライセンス数")}
                      </div>
                      <div className={style.licenseModalLicenseItemValue}>
                        {licenseChangeAfterInfo?.diff_license_count}
                      </div>
                    </div>
                    <div className={style.licenseModalLicenseItem}>
                      <div className={style.licenseModalLicenseItemName}>
                        {t("LicenseChangeModal.合計ライセンス数")}
                      </div>
                      <div className={style.licenseModalLicenseItemValue}>{licenseCount}</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div>{t("LicenseChangeModal.ライセンスの削除は次回更新時に適用されます。")}</div>
              <div className={style.licenseModalContentWrap}>
                <div className={style.licenseModalStartingDate}>
                  <div className={style.licenseModalStartingDateItem}>{t("LicenseChangeModal.適用月")}</div>
                  <div className={style.licenseModalStartingDateValue}>
                    {licenseChangeAfterInfo?.apply_date?.downgrade}
                  </div>
                </div>
                <div className={style.licenseModalLicenseContent}>
                  <div className={style.licenseModalLicenseContent}>
                    <div className={style.licenseModalLicenseItem}>
                      <div className={style.licenseModalLicenseItemName}>
                        {t("LicenseChangeModal.適用後ライセンス数")}
                      </div>
                      <div className={style.licenseModalLicenseItemValue}>{licenseCount}</div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className={style.licenseChangeButtonWrap}>
            <SecondaryBtn
              text={t("LicenseChangeModal.戻る")}
              disabled={false}
              className="test-force-upgrade"
              submit={() => setCurrentPageNum(0)}
              style={{ color: "#222222", maxWidth: "194px", minWidth: "194px", width: "194px" }}
            />
            <InfoBtn
              text={t("LicenseChangeModal.申し込む")}
              loading={false}
              className="ml-auto test-force-upgrade"
              submit={() => licenseChange()}
              style={{ maxWidth: "194px", minWidth: "194px", width: "194px" }}
              disabled={licenseCount === currentUserLicense ? true : false}
            />
          </div>
        </div>
      )}
    </>
  );
};

LicenseChangeModal.propTypes = {
  client: PropTypes.string,
  handleClose: PropTypes.func,
  currentUserLicense: PropTypes.number,
  membersCount: PropTypes.number,
  currentPlan: PropTypes.object,
  setCurrentUserLicense: PropTypes.func,
  fetchLicenseDowngradeInfo: PropTypes.func,
  getNextPayment: PropTypes.func,
  defaultLicenseCount: PropTypes.number,
};
